/* RESPONSIBLE TEAM: team-ai-insights */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type RouterService from '@ember/routing/router-service';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';
import { taskFor } from 'ember-concurrency-ts';
import type Transition from '@ember/routing/transition';
import type ReportingUnderlyingDataService from 'embercom/services/reporting-underlying-data-service';

export default class TopicTrendsRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare router: RouterService;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare permissionsService: $TSFixMe;
  @service declare aiAgentSetupService: AiAgentSetupService;
  @service declare reportingUnderlyingDataService: ReportingUnderlyingDataService;

  analytics = {
    section: 'automation',
    place: 'topic-trends',
  };

  routeWhenNotOptedIn = 'apps.app.automation.fin-ai-agent.analyze.performance';

  get titleToken() {
    return this.intl.t('ai-agent.analyze.topic-trends');
  }

  async beforeModel(transition: Transition) {
    if (!this.appService.app.canSeeTrends) {
      this.router.transitionTo(this.routeWhenNotOptedIn);
      return;
    }
    this.permissionsService.ensurePermissionWhenTransitioning('can_access_reporting', transition);
    await Promise.all([
      taskFor(this.reportingMetrics.setup).perform(),
      taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
        'conversation_custom_fields#customer_experience_attributes',
        'conversation',
        true,
      ),
    ]);
    this.aiAgentSetupService.loadFinWorkflowsCount();
    this.aiAgentSetupService.loadSetupRulesets();
  }
}
